export default __webpack_public_path__ + "static/retail-flash-sale-68a7b07827e42ccfbc3659628ddcafbc.gif";